import React, { Component } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import Diskussionen from '../components/Diskussionen'; 
import {jsonUrl,children} from '../components/Factory';
import Flexbox from '../components/misc/Flexbox'; 
import SubmenuDiscussion from '../components/SubmenuDiscussion'; 

class DiskussionenContainer extends Component {
	constructor(props) {
		super(props);
		this.state = { 
		  childrenData: this.props.resolves.children,
		  offset : 6,
		  finished:'block'
		}
		this.onChange = this.onChange.bind(this);
	}
	onChange(isVisible){
		if(isVisible) { 
			this.loadMore();
		}
	}	
	loadMore(){
		fetch(children({ 	number:6,
							parent:this.props.resolves.page.id,
							offset:this.state.offset
						}))
					  .then(res => res.json())
					  .then(res => {
							if(res.length>0)
								this.setState({
									childrenData: [...this.state.childrenData,...res],
									offset: this.state.offset+6
								});
							else
								this.setState({
									finished:'none'
								});
					  })
	}
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}
	componentDidMount(){	
		setTimeout(function(){
			document.getElementById('menu-diskussionen').classList.add('active');
			document.getElementById('submenu-diskussionen').classList.add('active');
		},400);
	}
	componentWillUnmount(){
		document.getElementById('menu-diskussionen').classList.remove('active');
		document.getElementById('submenu-diskussionen').classList.remove('active');
	}
	render() {	
		   const { page } = this.props.resolves;
		   return (
				<div>
					<SubmenuDiscussion {...page} />
					<div className="container-fluid lg-side-padding article-list three-col">
						<Flexbox left={page.title_left} right={page.title_right} />
						<Diskussionen children={this.state.childrenData}  /> 
						<VisibilitySensor onChange={this.onChange}>
							<div className="loading small" style={{display:this.state.finished}}>
								<div className="one"></div>			
							</div>
						</VisibilitySensor>
					</div>
				</div>
				
			)
	   
	}
}
export function getChildren(){
	return fetch(jsonUrl({ 
						number:1,
						type:'pages',
						slug:'diskussionen'
					}))
				  .then(res => res.json())
				  .then(res => {
					  return fetch(children({
							number:6,
							parent:res[0].id,
							offset:0
					   }))
					   .then(res => res.json())
					   .then(res => {
							return res
					   })
				  })
}
export default DiskussionenContainer;


// WEBPACK FOOTER //
// ./src/containers/DiskussionenContainer.js